import { render, staticRenderFns } from "./DropDownCart.vue?vue&type=template&id=38a753bc&"
import script from "./DropDownCart.vue?vue&type=script&lang=js&"
export * from "./DropDownCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports